import axios from 'axios';

const getList = async function projectServiceGetList () {
  const response = await axios.get('/api/project?isArchive=false');

  return response.data.data;
};

const getListArchive = async function projectServiceGetList () {
  const response = await axios.get('/api/project?isArchive=true');

  return response.data.data;
};

const getById = async function projectServiceGetById (id) {
  const response = await axios.get(`/api/project/${id}`);

  return response.data.data;
};

const create = async function projectServiceCreate (data) {
  const response = await axios.post('/api/project', data);

  return response.data.data;
};

const update = async function projectServiceUpdate (id, data) {
  const response = await axios.put(`/api/project/${id}`, data);

  return response.data.data;
};

const remove = async function projectServiceRemove (id) {
  const response = await axios.delete(`/api/project/${id}`);

  return response.data.data;
};

export default {
  getList,
  getListArchive,
  getById,
  create,
  update,
  remove,
};
